export default "__VITE_ASSET__BcD1ADFR__"